const initialSaveProgressState = {
  saveInProgress: false,
  saveProgressStatus: 0,
};

export default initialSaveProgressState;
